/**
 * Class to work with storage
 *
 * Create a Collapse new class
 * @constructor
 * @param {string} type - Type of storage (local or session)
 */
var Storage = function(type) {
    if (type == undefined) {
         type = 'local';
    }

    this.type = type;
}

Storage.prototype.set = function(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
}

Storage.prototype.get = function(name) {
    var data = localStorage.getItem(name);

    if (data != null) {
        return JSON.parse(data);
    }

    return null;
}

Storage.prototype.remove = function(name) {
    var data = localStorage.getItem(name);

    if (data != null) {
        localStorage.removeItem(name);
    }

    return null;
}

Storage.prototype.clearAll = function() {
    localStorage.clear();
}

/** Export the class */
export default Storage;
